import React, { useState } from 'react';
import { Table, Row, Col, Button, Tag } from 'antd';
import { WrappedFormInternalProps } from '@ant-design/compatible/lib/form/Form';
import { FormattedMessage, useIntl } from 'react-intl';
import { Withdraw, WithdrawStatus } from '../WithdrawsTabs';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import TransferWithdraw from '../WithdrawsModal/TransferWithdraw';
import TransferCIMBWithdraw from '../WithdrawsModal/TransferCIMBWithdraw';
import CancelWithdraw from '../WithdrawsModal/CancelWithdraw';
import { satangToBath } from '../../../../helpers/format/satangToBath';
import renderIfHasPermissisons from '../../../../layouts/renderIfHasPermissisons';
import { iso8601ToLocalDate } from '../../../../helpers/date/date';
import moment from 'moment';

const columnsAll = [
  {
    title: <FormattedMessage id="withdraw.column.id" />,
    dataIndex: 'id',
    sorter: (a: any, b: any) => a.id.localeCompare(b.id),
  },
  { title: <FormattedMessage id="withdraw.column.loanId" />, dataIndex: 'loanId' },
  {
    title: <FormattedMessage id="withdraw.column.name" />,
    render: (data: Withdraw) => {
      return `${data.firstName} ${data.lastName}`;
    },
  },
  { title: <FormattedMessage id="company" />, dataIndex: 'companyName' },
  { title: <FormattedMessage id="withdraw.column.productName" />, dataIndex: 'productName' },
  {
    title: <FormattedMessage id="withdraw.column.amount" />,
    dataIndex: 'amount',
    render: (amount: number) => {
      return satangToBath(amount);
    },
  },
  { title: <FormattedMessage id="withdraw.column.bankName" />, dataIndex: 'bankName' },
  { title: <FormattedMessage id="withdraw.column.accountNo" />, dataIndex: 'accountNo' },
  {
    title: <FormattedMessage id="withdraw.column.createDate" />,
    dataIndex: 'createDate',
    render: (date: any) => {
      return iso8601ToLocalDate(date);
    },
  },
  {
    title: <FormattedMessage id="withdraw.column.status" />,
    render: (record: any) => (
      <Tag style={{ textAlign: 'center' }} color="purple">
        {record.status}
      </Tag>
    ),
  },
];

const TablePending: React.FC<any> = (props: any) => {
  let formRef: any;
  const intl = useIntl();
  const {
    dataSource,
    patchWithdraws,
    resetWithdraws,
    loading,
    transferWithdraws,
    pagination,
    onChange,
    currentProjectId,
  } = props;
  const [transferModalVisible, setTransferModalVisible] = useState<boolean>(false);
  const [transferCIMBModalVisible, setTransferCIMBModalVisible] = useState<boolean>(false);
  const [cancelModalVisible, setCancelModalVisible] = useState<boolean>(false);
  const [rows, setSelectedRows] = useState<any>([]);
  const [rowKeys, setRowKeys] = useState<any>([]);

  const rowSelection: any = {
    selectedRowKeys: rowKeys,
    onSelect: (record: any, selected: any, selectedRows: any) => {
      const oldRows = rows;
      let newRows = [];
      if (selected === true) {
        newRows = oldRows;
        newRows.push(record);
      }
      if (selected === false) {
        if (oldRows.length > 0) {
          newRows = oldRows.filter((row: any) => row.id !== record.id);
        }
      }
      const rowkeys = newRows.map((row: any) => row.id);
      setRowKeys(rowkeys);
      setSelectedRows(newRows);
    },

    onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
      const oldRows = rows;
      let newRows = [];
      if (selected === true) {
        newRows = oldRows;
        changeRows.map((row: any) => newRows.push(row));
      }
      if (selected === false) {
        if (oldRows.length > 0) {
          newRows = oldRows.filter(
            (oldRows: any) => !changeRows.find((changeRow: any) => changeRow.id === oldRows.id),
          );
        }
      }
      const rowkeys = newRows.map((row: any) => row.id);
      setRowKeys(rowkeys);
      setSelectedRows(newRows);
    },
  };

  function handleCancel() {
    setTransferModalVisible(false);
    setCancelModalVisible(false);
    setTransferCIMBModalVisible(false);
  }

  async function handleCreateTransfer() {
    const { form } = formRef.props;
    form.validateFields(async (err: any, value: any) => {
      if (err) {
        return;
      }
      const { transferredDate } = value;
      transferWithdraws(rows, WithdrawStatus.TRANSFERRED, transferredDate);
      form.resetFields();
      setTransferModalVisible(false);
    });
    setSelectedRows([]);
  }

  async function handleCreateTransferCIMB() {
    const { form } = formRef.props;
    form.validateFields(async (err: any, value: any) => {
      if (err) {
        return;
      }
      const transferredDate = moment()
        .utcOffset('+07:00')
        .format('YYYY-MM-DD');
      const type = 'cimb';
      transferWithdraws(rows, WithdrawStatus.TRANSFERRED, transferredDate, type);
      form.resetFields();
      setTransferCIMBModalVisible(false);
    });
    setSelectedRows([]);
  }

  async function handleCreateCancel() {
    patchWithdraws(rows, WithdrawStatus.CANCELLED);
    setSelectedRows([]);
    setCancelModalVisible(false);
  }

  function saveFormRef(formRefs: WrappedFormInternalProps) {
    formRef = formRefs;
  }
  const ActionButtonPanel = () => {
    return (
      <div style={{ marginBottom: '16px' }}>
        <Row gutter={6}>
          <Col span={24} style={{ textAlign: 'left' }}>
            <Button
              type="primary"
              disabled={rows.length === 0}
              onClick={() => {
                setTransferModalVisible(true);
              }}
              ghost
            >
              <FormattedMessage id="withdraw.button.transfer" />
            </Button>
            {currentProjectId === '760296' || currentProjectId === '640579' ? (
              <Button
                style={{ marginLeft: 8 }}
                type="primary"
                disabled={rows.length === 0}
                onClick={() => {
                  setTransferCIMBModalVisible(true);
                }}
                ghost
              >
                <FormattedMessage id="withdraw.button.transfer.cimb" />
              </Button>
            ) : (
              ''
            )}
            <Button
              style={{ marginLeft: 8 }}
              danger
              disabled={rows.length === 0}
              onClick={() => {
                setCancelModalVisible(true);
              }}
              ghost
            >
              <FormattedMessage id="withdraw.button.cancel" />
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              danger
              disabled={rows.length === 0}
              onClick={() => {
                resetWithdraws(rows);
              }}
              ghost
            >
              <FormattedMessage id="withdraw.button.reset" />
            </Button>
          </Col>
        </Row>
        <TransferWithdraw
          wrappedComponentRef={saveFormRef}
          visible={transferModalVisible}
          onCancel={handleCancel}
          onCreate={handleCreateTransfer}
        />
        <CancelWithdraw
          visible={cancelModalVisible}
          onCancel={handleCancel}
          onCreate={handleCreateCancel}
          cancelText={intl.formatMessage({ id: 'no' })}
          okText={intl.formatMessage({ id: 'yes' })}
        />
        <TransferCIMBWithdraw
          rows={rows}
          visible={transferCIMBModalVisible}
          onCancel={handleCancel}
          onCreate={handleCreateTransferCIMB}
        />
      </div>
    );
  };
  const CheckPermission = renderIfHasPermissisons('withdraws.*.update', <ActionButtonPanel />);
  return (
    <div>
      <CheckPermission />
      <Table
        rowKey="id"
        rowSelection={rowSelection}
        dataSource={dataSource}
        loading={loading}
        columns={columnsAll}
        pagination={pagination}
        onChange={onChange}
      />
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  currentProjectId: state.user.currentProjectId,
});

export default connect(mapStateToProps, { push })(TablePending);
